const colors = [
  "#CE6CD5",
  "#81BAFF",
  "#2D0E54",
  "#C4C400",
  "#FC4F95",
  "#A76E11",
  "#00D1D5",
  "#337E80",
  "#6F0FFF",
  "#FFC1A6",
  "#A62273",
  "#FDBE57"
];

export default colors;



// WEBPACK FOOTER //
// ./routes/conferences/Colors.js